// extracted by mini-css-extract-plugin
export var section = "Section-module--section--1gyeU";
export var biggerMargin = "Section-module--biggerMargin--dy6IE";
export var spinAround = "Section-module--spinAround--2aKpk";